import {useStore} from "@/store";

export default function noProfile({next, router}: {next: any, router: any}) {
    const store = useStore()
    if (store.state.settings.profile)
        return router.push('/')
    return next()
}
